(() => {
  const init = (root) => {
    if (root.dataset.hctReady) return;
    root.dataset.hctReady = "true";

    const tabs = [...root.querySelectorAll("[data-hct-tab]")];
    const panels = [...root.querySelectorAll("[data-hct-panel]")];

    const mobile = () => matchMedia("(max-width: 989px)").matches;

    const select = (id, mayClose = false) => {
      const tab = tabs.find((t) => t.dataset.hctTab === id);

      const close =
        mayClose && tab?.getAttribute("aria-selected") === "true";

      tabs.forEach((t) => {
        const active = !close && t.dataset.hctTab === id;

        t.classList.toggle("is-active", active);
        t.setAttribute("aria-selected", String(active));
      });

      panels.forEach((p) => {
        p.hidden = close || p.dataset.hctPanel !== id;
      });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener("pointerenter", () => {
        if (!mobile()) {
          select(tab.dataset.hctTab);
        }
      });

      tab.addEventListener("focus", () => {
        if (!mobile()) {
          select(tab.dataset.hctTab);
        }
      });

      tab.addEventListener("click", () => {
        select(tab.dataset.hctTab, mobile());
      });

      tab.addEventListener("keydown", (e) => {
        if (
          !["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(e.key)
        ) {
          return;
        }

        e.preventDefault();

        const step = ["ArrowDown", "ArrowRight"].includes(e.key) ? 1 : -1;

        tabs[(i + step + tabs.length) % tabs.length].focus();
      });
    });
  };

  const boot = () => {
    document
      .querySelectorAll("[data-horizon-collection-tabs]")
      .forEach(init);
  };

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();